@if(pdp()){

<div class="header">

  <button class="btn btn-rounded btn-light" (click)="handleGoBack()">
    <img src="assets/icons/back.svg" alt="">
  </button>

  <div class="title">
    {{pdp()?.aestheticLine}}
  </div>

  <div class="right-side">

    <!-- Visualizzo la dropdown solo se sono un utente di tipo STORE -->
    <!-- Nascondo la dropdown per il PEZZOTTI di PORTO RICO -->
    @if(authService.user?.isUserStore && !hideViewStockOptions){
    <div class="dropdown" [hidden]="hideStockViewMenu" appDropdown>

      <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
        {{selectedViewStock()|translate}}
      </button>

      <ul class="dropdown-menu">
        @for(opt of viewStockOptions; let i = $index; track opt){
        <li>
          <button class="dropdown-item" [disabled]="selectedViewStock() === opt" (click)="handleStockViewChange(opt)">
            {{opt|translate}}
          </button>
        </li>
        }
      </ul>

    </div>
    }

    <div class="dropdown" [hidden]="viewStock()" appDropdown>

      <button class="btn btn-rounded btn-light dropdown-toggle" data-bs-toggle="dropdown">
        @if(downloadingPdf()){
        <div class="spinner-wrapper pdf">
          <div class="spinner-border text-dark " role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        }@else {
        <img src="assets/icons/pdf.svg" alt="">
        }
      </button>

      <ul class="dropdown-menu">
        <li>
          <button class="dropdown-item" (click)="getProductCard()">
            {{"Product Card"|translate}}
          </button>
        </li>
        <li>
          <button class="dropdown-item" (click)="getProductCard(true)">
            {{"Product Card & Pricelist"|translate}}
          </button>
        </li>
      </ul>

    </div>


    <div class="dropdown" [hidden]="viewStock()" appDropdown>

      <button class="btn btn-rounded btn-light dropdown-toggle" data-bs-toggle="dropdown">
        <img src="assets/icons/ellipsis.svg" alt="">
      </button>

      <ul class="dropdown-menu">

        @if(stoneMedia().length > 0){
        <li>
          <button class="dropdown-item" (click)="downloadStoneMedia()" [disabled]="!stoneMedia()[0]">
            {{"View Gemstone Letter"|translate}}
            <img src="assets/icons/file.svg" alt="file">
          </button>
        </li>
        }

        @if(attachments().length > 0){
        <li>
          <button class="dropdown-item" (click)="handleOpenAttachmentsModal()">
            {{"View Attachments"|translate}}
            <img src="assets/icons/file.svg" alt="file">
          </button>
        </li>
        }

        @if(pdp()?.hotStamping){
        <li>
          <a href="assets/pdf/hotstamping.pdf" download="hotstamping.pdf" class="dropdown-item">
            {{"Hot Stamping"|translate}}
            <img src="assets/icons/file.svg" alt="Download hot stamping">
          </a>
        </li>
        }

        @if(pdp()?.hasLabMedias && (this.pdp()!.labMedias.length > 0 || this.pdp()!.labMediaImages.length > 0)){
        <li>
          <button class="dropdown-item" (click)="handleOpenJewelDetailModal()">
            {{"View Jewel Detail"|translate}}
            <img src="assets/icons/jewel.svg" alt="DW">
          </button>
        </li>
        }

        @if(dwUrl){
        <li>
          <a [attr.href]="dwUrl" class="dropdown-item" target="_blank">
            {{"Go To Digital World"|translate}}
            <img src="assets/icons/dw.svg" alt="DW">
          </a>
        </li>
        }

        @if(digitalPassportUrl()){
        <li>
          <a [attr.href]="digitalPassportUrl()" class="dropdown-item" target="_blank">
            {{"Digital Passport"|translate}}
          </a>
        </li>
        }

        @if(amvVideos().length > 0){
        @for(video of amvVideos(); track $index){
        <li>
          <a [attr.href]="video.url" class="dropdown-item" target="_blank">
            {{"Show Eternal AMV"|translate}}
          </a>
        </li>
        }
        }

        @if(accessoriesMedia().length > 0){
        @for(media of accessoriesMedia(); track $index){
        <li>
          <a [attr.href]="media" class="dropdown-item" target="_blank">
            {{"Icons Minaudière"|translate}}
          </a>
        </li>
        }
        }

      </ul>

    </div>

  </div>

</div>

<div class="pdp-page container-fluid">

  <div class="row">

    <div class="col col-1">

      @if(viewStock()){

      @if(!isBatchManaged){

      <app-size-selector [sizes]="sizesWithStock()" [sapCode]="pdp()!.sapCode" (handleSelectSize)="loadPDP($event)"
        [loading]="showStockLoader()"></app-size-selector>

      }

      }@else {
      <app-media-selector [media]="media" [selectedMedia]="selectedMedia"></app-media-selector>
      }

    </div>

    <div class="col col-5">

      <app-media-preview [selectedMedia]="selectedMedia" [selectedVideo]="selectedVideo"
        [selectedMediaType]="selectedMediaType()" (handleSelectMediaType)="handleSelectMedia($event)"
        (handleOpenFullScreenModal)="handleOpenFullScreenModal($event)" [canShowImageButton]="canShowImageButton"
        [canShowVideoButton]="canShowVideoButton" [canShowModel3DButton]="canShowModel3DButton">
      </app-media-preview>

    </div>

    <div class="col col-6" [class.stock-view]="viewStock()">

      @if(viewStock()){

      <app-stock [pdp]="pdp()" [price]="price()" [viewStockType]="selectedViewStock()" [stock]="stock()"
        [batchStock]="batchStock()" [hewStock]="hewStock()" [hqStock]="hqStock()" [hqBatchStock]="hqBatchStock()"
        [loading]="showStockLoader()"></app-stock>

      }@else {

      <app-detail [pdp]="pdp()" [parure]="parureParsedInProduct()" [price]="price()"
        [highJewelryStockInfo]="highJewelryStockInfo()" [showStockLoader]="showStockLoader" (loadPDP)="loadPDP($event)"
        (viewStock)="switchToStockView()"></app-detail>

      }

    </div>

  </div>

</div>

}@else if(!loaderService.loading()){

<app-placeholder [message]="'An error occurred'|translate" />

}

<app-full-screen-modal #fullScreenModal></app-full-screen-modal>

<app-attachments-modal #attachmentModal></app-attachments-modal>

<app-jewel-detail-modal #jewelDetailModal></app-jewel-detail-modal>
